// extracted by mini-css-extract-plugin
module.exports = {"header":"reportElementWrapper_header__2UOPD"};